import * as Sentry from '@sentry/react';
import { type Color, converter, formatHex, type Oklch, parse } from 'culori';

/**
 * Convert any CSS color string to OKLCH color space
 */
const toOklchConverter = converter('oklch');

export function toOklch(color: string | Color): Oklch {
  const parsed = typeof color === 'string' ? parse(color) : color;
  if (!parsed) {
    Sentry.logger.warn(`Failed to parse color: ${color}`);
    return { mode: 'oklch', l: 0, c: 0, h: 0 };
  }
  return toOklchConverter(parsed) as Oklch;
}

/**
 * Convert any CSS color string (including oklch) to hex format.
 * Three.js doesn't support oklch natively, so we need to convert.
 */
export function toHex(color: string | Color): string {
  const parsed = typeof color === 'string' ? parse(color) : color;
  if (!parsed) {
    Sentry.logger.warn(`Failed to parse color: ${color}`);
    return '#ffffff';
  }
  return formatHex(parsed);
}
